import { atom } from "@mongez/react-atom";
import { CustomOptionRequest } from "core/cart";

export const selectedCustomOptionsAtom = atom<CustomOptionRequest[]>({
  key: "selected-custom-options",
  default: [],
});
